// libs
import React from 'react';

// components
import { SHEET_TRANSITION } from 'shared/components/OverlaySheet';

// svgs
import CircleCrossWhite from '@nykaa/ui-components/Icons/circle-x-duotone';
import ArrowLeft from '@nykaa/ui-components/Icons/arrow-left';

// styles
import { ViewDetailsContainer, CloseIcon, CouponErrorHeader, CouponErrorPage } from './styles';

// defs
interface CouponOfferErrorProps {
  onHide: VoidFunction;
  className?: string;
  sheetTransition?: SHEET_TRANSITION;
  title?: string;
  subtitle?: string;
  imageUrl?: string;
  actionName?: string;
  showBackButton?: boolean;
  showOverlay?: boolean;
  setParentSheetHeight?: (height: number) => void | null;
  onActionButtonClick: () => void;
}

function CouponOfferError({
  onActionButtonClick,
  showBackButton = false,
  title = '',
  subtitle = '',
  imageUrl = '',
  actionName = '',
}: CouponOfferErrorProps) {
  return (
    <ViewDetailsContainer className="coupon-offer-error">
      <CouponErrorHeader>
        {showBackButton ? (
          <CloseIcon className="close-icon" onClick={onActionButtonClick}>
            <ArrowLeft />
          </CloseIcon>
        ) : (
          <CloseIcon className="close-icon" onClick={onActionButtonClick}>
            <CircleCrossWhite />
          </CloseIcon>
        )}
      </CouponErrorHeader>
      <CouponErrorPage
        title={title}
        subtitle={subtitle}
        imageUrl={imageUrl}
        actionName={actionName}
        onActionButtonClick={onActionButtonClick}
        className="coupon-offer-wrapper"
      />
    </ViewDetailsContainer>
  );
}

export default CouponOfferError;
